import {
    TEAM_MEMBER_INTERVIEW_REQUEST, TEAM_MEMBER_INTERVIEW_FAIL, TEAM_MEMBER_INTERVIEW_SUCCESS
  } from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    action: "Job Action",
    result: [],
    msg: "",
    error: "",
  };
  
  const TeamMemberInterviewReducer = (state = initialState, action) => {
    switch (action.type) {
      case TEAM_MEMBER_INTERVIEW_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case TEAM_MEMBER_INTERVIEW_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.payload,
          msg: action.msg,
        };
      case TEAM_MEMBER_INTERVIEW_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default TeamMemberInterviewReducer;
  